import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { FindMappingByTypeResponseDto } from "~/gen/api"
import { useFindTypeKeysQuery } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useFindTypeKeysQuery"

import { MappingTable } from "../components/MappingTable"

type Props = {
  productTypes: FindMappingByTypeResponseDto[]
}

export const ProductMapping = ({ productTypes }: Props) => {
  const {
    data: productTypesList,
    isLoading,
    isError,
  } = useFindTypeKeysQuery("PRODUCT")
  const { t } = useTranslation()

  if (isLoading) {
    return <Loader />
  }

  if (isError) {
    return (
      <InfoBox
        color="red"
        title={t("dataLoad.error.title")}
        message={t("dataLoad.error.message")}
      />
    )
  }

  return (
    <>
      <MappingTable
        types={productTypes}
        typesList={productTypesList.data.map((type) => ({
          ...type,
          deletedAt: type.deletedAt ? new Date(type.deletedAt) : null,
        }))}
        typeName="PRODUCT"
      />
    </>
  )
}
